import {
  CLEAR_POSSIBLE_CONTACTS,
  CREDIT_APPLICATIONS_LOADING,
  GET_APPLICATION_PREVIEW,
  GET_CEF_BANK_REFERENCES,
  GET_CEF_LOANS,
  GET_CEF_OWNERS,
  GET_CEF_PAST_EMPLOYMENTS,
  GET_CEF_PERSONAL_REFERENCES,
  GET_CEF_RESIDENCES,
  GET_CREDIT_APPLICATION,
  GET_CREDIT_APPLICATIONS,
  GET_POSSIBLE_CONTACTS,
  ASSIGN_CREDIT_APPLICATIONS,
} from './applicationTypes'

const initData = { data: [], query: { first: 0, limit: 5, totalRecords: 0 } }

const initState = {
  loading: false,
  data: {},
  application: {},
  contacts: {
    data: [],
    query: { first: 0, limit: 5, totalRecords: 0 },
  },
  cef: {
    loans: initData,
    owners: initData,
    applicantResidences: initData,
    coApplicantResidences: initData,
    applicantPastEmployments: initData,
    coApplicantPastEmployments: initData,
    applicantBankReferences: initData,
    coApplicantBankReferences: initData,
    applicantPersonalReferences: initData,
    coApplicantPersonalReferences: initData,
  },
  preview: {},
}

const CreditApplicationsReducer = (state = initState, action) => {
  switch (action.type) {
    case GET_CREDIT_APPLICATIONS:
      return { ...state, data: action.payload }
    case CREDIT_APPLICATIONS_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    case GET_CREDIT_APPLICATION:
      return {
        ...state,
        application: action.payload,
      }
    case GET_POSSIBLE_CONTACTS:
      return {
        ...state,
        contacts: action.payload,
      }
    case CLEAR_POSSIBLE_CONTACTS:
      return {
        ...state,
        contacts: initState.contacts,
      }
    case GET_APPLICATION_PREVIEW:
      return {
        ...state,
        preview: action.payload,
      }
    case GET_CEF_LOANS:
      return {
        ...state,
        cef: {
          ...state.cef,
          loans: action.payload,
        },
      }
    case GET_CEF_OWNERS:
      return {
        ...state,
        cef: {
          ...state.cef,
          owners: action.payload,
        },
      }
    case GET_CEF_RESIDENCES:
      return {
        ...state,
        cef: {
          ...state.cef,
          [action.isApplicant ? 'applicantResidences' : 'coApplicantResidences']: action.payload,
        },
      }
    case GET_CEF_PAST_EMPLOYMENTS:
      return {
        ...state,
        cef: {
          ...state.cef,
          [action.isApplicant ? 'applicantPastEmployments' : 'coApplicantPastEmployments']: action.payload,
        },
      }
    case GET_CEF_PERSONAL_REFERENCES:
      return {
        ...state,
        cef: {
          ...state.cef,
          [action.isApplicant ? 'applicantPersonalReferences' : 'coApplicantPersonalReferences']: action.payload,
        },
      }
    case GET_CEF_BANK_REFERENCES:
      return {
        ...state,
        cef: {
          ...state.cef,
          [action.isApplicant ? 'applicantBankReferences' : 'coApplicantBankReferences']: action.payload,
        },
      }
    case ASSIGN_CREDIT_APPLICATIONS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      }
    default:
      return state
  }
}

export default CreditApplicationsReducer
